import React from 'react';

function Step2otropais({ 
  formData, 
  errors, 
  onChange, 
  departamentos, 
  municipiosResidencia 
}) { 
  // Función para bloquear físicamente la pulsación de números (0-9) en el teclado
  // Solo permite letras, espacios, tildes y ñ
  const blockNumbers = (e) => {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    // Permitir teclas de control
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Home" ||
      e.key === "End"
    ) {
      return;
    }

    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  // Función para evitar que el usuario copie y pegue texto que contenga números
  const blockNumbersOnPaste = (e) => {
    const texto = e.clipboardData.getData("text");
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;

    if (!regex.test(texto)) {
      e.preventDefault();
    }
  };
  return (
    <div className="step-panel">
      
      {/* PAÍS DE NACIMIENTO */}
      <div className="field-group">
        <label htmlFor="paisNacimient">
          ¿Cuál es su país de nacimiento? <span className="required">*</span>
        </label>
        <input
          id="paisNacimient"
          name="paisNacimient"
          type="text"
          value={formData.paisNacimient || ''}
          onChange={onChange}
          onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
          onPaste={blockNumbersOnPaste}
          placeholder="Ingrese su país de nacimiento"
          className={errors.paisNacimient ? 'error-field' : ''}
        />
        {errors.paisNacimient && <span className="field-error">{errors.paisNacimient}</span>}
      </div>

      {/* LUGAR EXPEDICIÓN */}
      <div className="field-group">
        <label htmlFor="lugarExpedicion">
          Lugar de expedición del documento <span className="required">*</span>
        </label>
        <input
          id="lugarExpedicion"
          name="lugarExpedicion"
          type="text"
          value={formData.lugarExpedicion || ''}
          onChange={onChange}
          onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
          onPaste={blockNumbersOnPaste}
          placeholder="Municipio y departamento de expedición del documento"
          className={errors.lugarExpedicion ? 'error-field' : ''}
        />
        {errors.lugarExpedicion && <span className="field-error">{errors.lugarExpedicion}</span>}
      </div>

      {/* FECHA EXPEDICIÓN */}
      <div className="field-group">
        <label htmlFor="fechaExpedicion">
          Fecha de Expedición del Documento <span className="required">*</span>
        </label>
        <input
          id="fechaExpedicion"
          name="fechaExpedicion" // Unificado a fechaExpedicion
          type="date"
          value={formData.fechaExpedicion || ''}
          onChange={onChange}
          className={errors.fechaExpedicion ? 'error-field' : ''}
        />
        {errors.fechaExpedicion && <span className="field-error">{errors.fechaExpedicion}</span>}
      </div>

      {/* DEPARTAMENTO RESIDENCIA */}
      <div className="field-group">
        <label htmlFor="departamentoResidencia">
          Departamento de Residencia <span className="required">*</span>
        </label>
        <select
          id="departamentoResidencia"
          name="departamentoResidencia" // Corregido: añadido la 'o' para sincronizarse al estado global
          value={formData.departamentoResidencia || ''}
          onChange={onChange}
          className={errors.departamentoResidencia ? 'error-field' : ''}
        >
          <option value="">Seleccione...</option>
          {departamentos.map(dep => (
            <option key={dep.id} value={dep.nombre}>
              {dep.nombre}
            </option>
          ))}
        </select>
        {errors.departamentoResidencia && <span className="field-error">{errors.departamentoResidencia}</span>}
      </div>

      {/* MUNICIPIO RESIDENCIA */}
      <div className="field-group">
        <label htmlFor="municipioResidencia">
          Municipio de Residencia <span className="required">*</span>
        </label>
        <select
          id="municipioResidencia"
          name="municipioResidencia" // Corregido: añadido la 'a' final para sincronizarse al estado global
          value={formData.municipioResidencia || ''}
          onChange={onChange}
          disabled={!formData.departamentoResidencia} // Corregido el trigger del disabled
          className={errors.municipioResidencia ? 'error-field' : ''}
        >
          <option value="">Seleccione un municipio...</option>
          {municipiosResidencia.map((municipio) => (
            <option key={municipio.id || municipio.id_municipio || municipio.idMunicipio} value={municipio.nombre}>
              {municipio.nombre}
            </option>
          ))}
        </select>
        {errors.municipioResidencia && <span className="field-error">{errors.municipioResidencia}</span>}
      </div>

      {/* BARRIO RESIDENCIA */}
      <div className="field-group">
        <label htmlFor="barrioResidencia">
          Barrio de Residencia <span className="required">*</span>
        </label>
        <input
          id="barrioResidencia"
          name="barrioResidencia"
          type="text"
          value={formData.barrioResidencia || ''}
          onChange={onChange}
          placeholder="Ingrese el barrio de residencia"
          className={errors.barrioResidencia ? 'error-field' : ''}
        />
        {errors.barrioResidencia && <span className="field-error">{errors.barrioResidencia}</span>}
      </div>

      {/* DIRECCIÓN RESIDENCIA */}
      <div className="field-group">
        <label htmlFor="direccionResidencia">
          Dirección de Residencia <span className="required">*</span>
        </label>
        <input
          id="direccionResidencia"
          name="direccionResidencia"
          type="text"
          value={formData.direccionResidencia || ''}
          onChange={onChange}
          placeholder="Ingrese su dirección"
          className={errors.direccionResidencia ? 'error-field' : ''}
        />
        {errors.direccionResidencia && <span className="field-error">{errors.direccionResidencia}</span>}
      </div>
    </div>
  );
}

export default Step2otropais;